<template>
  <div class="app-container">
    <form-table
      ref="baseForm"
      :queryOptions="searchFormData"
      :tableOptions="tableOptions"
      :headerTitle="headerTitle"
      :queryUrl="queryUrl"
      :btnData="btnData"
      @clickBtn="onSelect"
      :hasFormatFunctionParams="true"
      :formatFunctionParams="formatFunctionParams"
      :query-permission="['system:notice:query']"
    >
    </form-table>
  </div>
</template>

<script>
import { dataCenter } from '@/utils/dataCenter'
import { getDicts } from '@/api/dict/data'
export default {
  name: 'LOAContract',
  dicts: ['sys_dealer_type'],
  data() {
    return {
      headerTitle: 'LOA合同',
      btnData: [{ text: '下载' }],
      searchFormData: [
        { props: 'displayFileName', label: '文件名', type: 'input' },
        { props: 'terminalName', label: '终端名称', type: 'input' },
        {
          props: 'dateFieldTwoStart',
          label: '生效日期',
          width: '120px',
          type: 'dateTime',
          valueFormat: 'yyyy-MM-dd',
          dateFormat: 'yyyy-MM-dd',
          dateType: 'date'
        },
        {
          props: 'dateFieldOneEnd',
          label: '失效日期',
          width: '120px',
          type: 'dateTime',
          valueFormat: 'yyyy-MM-dd',
          dateFormat: 'yyyy-MM-dd',
          dateType: 'date'
        },
        { props: 'productLine', label: '产品线', type: 'input' },
        { props: 'textFieldOne', label: '市场领域', type: 'input' },
        { props: 'terminalCode', label: '终端代码', type: 'input' }
      ],
      tableOptions: [
        {
          prop: 'displayFileName',
          label: '文件名',
          type: 'fileName',
          'show-overflow-tooltip': true,
          sortable: true
        },
        {
          prop: 'terminalName',
          label: '终端名称',
          width: '150',
          'show-overflow-tooltip': true,
          sortable: false
        },
        {
          prop: 'dateFieldOne',
          label: '生效日期',
          width: '120',
          sortable: true
        },
        {
          prop: 'dateFieldTwo',
          label: '失效日期',
          width: '120',
          sortable: true
        },
        {
          prop: 'productLine',
          label: '产品线',
          'show-overflow-tooltip': true,
          width: '120',
          sortable: true
        },
        {
          prop: 'textFieldOne',
          label: '市场领域',
          'show-overflow-tooltip': true,
          sortable: false
        },
        {
          prop: 'terminalCode',
          label: '终端代码',
          width: '150',
          'show-overflow-tooltip': true,
          sortable: false
        }
      ],
      funCode: 'LOA_CONTRACT',
      queryUrl: '/bff-dp-mobile/meta-data-integration/data-list'
    }
  },
  created() {
    // this.setOptions()
  },
  methods: {
    formatFunctionParams(params) {
      const customDataSearchTypeMap = {
        terminalCode: 'LIKE',
        terminalName: 'LIKE'
      }
      let customDataSearchType = {}
      Object.keys(params).forEach(item => {
        if (customDataSearchTypeMap[item] && params[item]) {
          customDataSearchType = {
            ...customDataSearchType,
            [item]: customDataSearchTypeMap[item]
          }
        }
      })
      return {
        ...params,
        funCode: this.funCode,
        reservedDateFormat: 'yyyy-MM-dd',
        customData: {
          terminalCode: params.terminalCode,
          terminalName: params.terminalName
        },
        customDataSearchType: customDataSearchType
      }
    },
    async setOptions() {
      const options = await getDicts('sys_dealer_type').then(res => {
        let list = []
        if (res.code === 200 && res.data.length > 0) {
          list = res.data
        }
        return list
      })
      this.tableOptions[0].rightBottom.options = options
    },
    onSelect(text, queryParams, list) {
      console.log(text, queryParams)
      this.daowload(list)
    },
    daowload(list) {
      dataCenter.downloadFile(list)
    }
  }
}
</script>
